import React from 'react';
import { valueForKeyPath as v } from '../../../../utils.jsx';
import ArticleWidget from './ArticleWidget.jsx';

// Text widget
class ArticleWidgetText extends ArticleWidget {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.preview) {
      return (
        <div className="panel panel-default widget-body">
          <div className="panel-heading clearfix">
            <strong className="panel-title">
              {v(this.props.data, 'header', '')}
            </strong>
          </div>
          <div className="panel-body">
            <p>{v(this.props.data, 'text', '')}</p>
          </div>
        </div>
      );
    } else {
      return super.render();
    }
  }

  renderWidget() {
    return (
      <div>
        <div className="form-group">
          <input
            onChange={this.onChange}
            name="header"
            value={v(this.props.data, 'header', '')}
            type="text"
            placeholder="Nadpis textového bloku"
            className="form-control"
          />
        </div>
        <div className="form-group">
          <textarea
            onChange={this.onChange}
            name="text"
            value={v(this.props.data, 'text', '')}
            placeholder=""
            rows="5"
            cols="80"
            className="form-control"
          />
        </div>
      </div>
    );
  }
}

export default ArticleWidgetText;



// WEBPACK FOOTER //
// ./src/js/app/cm/components/ArticleWidgets/ArticleWidgetText.jsx